import React from 'react';
import { Placeholder, Table } from 'react-bootstrap-5';
import { useSelector } from 'react-redux';
import { faRectangleHistoryCircleUser } from '@fortawesome/pro-solid-svg-icons';

import CallListItemTableRow from './call_list_items_table_row';
import EmptyState from '../empty_state';
import { selectLoading } from '../store/selectors/ui';
import { selectCallListItems } from '../store/selectors/results';

type CallListItemsTableProps = {
  callListId: number;
  lastUpdatedMap: Map<number, Date>;
}

export default function CallListItemsTable({ callListId, lastUpdatedMap }: CallListItemsTableProps) {
  const callListItems = useSelector(selectCallListItems);
  const loading = useSelector(selectLoading);

  return (
    <div className="table-responsive h-100 overflow-auto position-relative bg-white z-2">
      <Table borderless className="call-list-table sticky-table w-100">
        <thead className="bg-light">
          <tr className="border-bottom d-none d-lg-table-row sticky-heading">
            <th className="d-lg-none py-3 px-4"></th>
            <th className="sticky-cell py-3 px-4" style={{ minWidth: 360 }}>Property</th>
            <th className="d-none d-xl-table-cell py-3 px-4" style={{ width: 209 }}>
              Contacts
            </th>
            <th className="py-3 px-4" style={{ width: 280 }}>Last Activity</th>
            <th className="py-3 px-4" style={{ width: 280 }}>Added</th>
            <th className="py-3 px-4">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="border-0" id="call_list_items">
          {loading ? (
            Array.from({ length: 20 }).map((_, i) => (
              <tr key={i}>
                {Array.from({ length: 5 }).map((_, j) => (
                  <td className="py-3 px-4" key={j}>
                    <Placeholder animation="wave">
                      <div>
                        <Placeholder as="div" className="rounded" xs={12} />
                      </div>
                    </Placeholder>
                  </td>
                ))}
              </tr>
            ))
          ) : (
            callListItems.map(callListItem => (
              <CallListItemTableRow
                callListId={callListId}
                callListItem={callListItem}
                key={callListItem.id}
                lastUpdated={lastUpdatedMap[callListItem.id]}
              />
            )))}
        </tbody>
      </Table>
      {(!loading && callListItems.length < 1) &&
        <div className="d-flex justify-content-center align-items-center w-100">
          <EmptyState icon={faRectangleHistoryCircleUser}
            iconSize="2x"
            text="Add properties to this call list to see them here."
            title="No items in this call list"
          />
        </div>
      }
    </div>
  );
}
